import React from "react";
import moment from "moment";
import styles from "./styles.module.scss";
import { useCurrentUserQuery } from "../../../../../../../api/queries/useUserQuery";
import { PREVIEW_DATE_FORMAT } from "../../../../../../../consts/general";

export function Date({ children }) {
  const { data: user } = useCurrentUserQuery();

  return (
    <div className={styles.root}>
      <span>Last Changed: </span>
      {children
        ? moment
            .utc(children)
            .format(user?.previewDateFormat || PREVIEW_DATE_FORMAT)
        : "Never"}
    </div>
  );
}
